module.exports = __webpack_public_path__ + "img/mn.44c868ec.svg";